export default {
  currencyexchange: {
    searchPlaceholder: '请输入币种编号或名称查询',
    currencyNo: '币种编号',
    currencyName: '币种名称',
    exchangeRate: '汇率',
    remarks: '备注',
    addTitle: '币种汇率',
    errorTip: '必须是非负数字!',
    modifyTitle: '编辑币种汇率'
  },
  taxexchange: {
    searchPlaceholder: '请输入税种编号或税种名称查询',
    taxTypeNo: '税种编号',
    taxTypeName: '税种名称',
    taxRate: '税率（%）',
    taxRateSign: '是否含税（Y/N）',
    addTitle: '税种税率',
    taxRateFlag: '是否含税'
  },
  paymentterm: {
    searchPlaceholder: '请输入付款条件编号或付款条件名称查询',
    payTermsNo: '付款条件编号',
    payTermsName: '付款条件名称',
    addTitle: '付款条件'
  },
  tradeterm: {
    searchPlaceholder: '请输入交易条件编号或付款条件名称查询',
    txTermsNo: '交易条件编号',
    txTermsName: '交易条件名称',
    addTitle: '交易条件'
  },
  supplyratio: {
    searchPlaceholder: '输入料号进行搜索',
    throw: '抛转ERP',
    transferSignMes: '存在已抛转单据，请重新选择',
    edition: '版本',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    transferSign: '抛转状态',
    addTitle: '新增供货比例',
    tableTitle: '供应商供应比例',
    supOfficeNo: '供应商',
    purchaseRatio: '供货比例（%）',
    supOfficeNoRequired: '请选择供应商',
    purchaseRatioMes: '供货比例（%）总和不等于100',
    detailTitle: '供货比例详情',
    currentRatio: '当前供货比例',
    historyRatio: '历史供货比例',
    effectiveDate: '生效日期',
    invalidDate: '失效日期',
    remarks: '备注',
    historicalVersion: '历史版本{edition}',
    purchaseUnitNo: '采购中心'
  }
}
